import FetcherApi from "components/components/FetcherApi";
import urlTools from "components/tools/urlTools";
import SmartIdErrorMessagesService from "components/services/SmartIdErrorMessagesService";
import { SMART_ID_POLLING_RESULT } from "components/account/SmartId/Shared/smartIdConstants";

const makeGetRequest = async (url) => {
    const httpResponse = await FetcherApi.get(url);
    return httpResponse.response.data;
};

const makePostRequest = async (url, data) => {
	const httpResponse = await FetcherApi.post(url, data);
	return httpResponse.response.data;
};

const handleBasicResponse = (result) => {
	if (!result.success) {
		const errorMessage = SmartIdErrorMessagesService.getErrorMessage(result.error);
		return { success: false, error: errorMessage };
	}
	return { success: true, data: result.resultObject };
};

const handlePollingResponse = (result, successData = null) => {
	if (!result.success) {
		if (result.error === "smart_id_session_expired") {
			return {
				status: SMART_ID_POLLING_RESULT.EXPIRED,
				error: SmartIdErrorMessagesService.getErrorMessage(result.error)
			};
		}
		if (result.error) {
			return {
				status: SMART_ID_POLLING_RESULT.ERROR,
				error: SmartIdErrorMessagesService.getErrorMessage(result.error)
			};
		}
		return { status: SMART_ID_POLLING_RESULT.CONTINUE };
	}

	const response = { status: SMART_ID_POLLING_RESULT.SUCCESS };
	if (successData) {
		Object.assign(response, successData);
	}
	return response;
};

export const smartIdApi = {
	async startPersonalCodeSession(personalCode, legalEntityId) {
		const result = await makePostRequest(
			urlTools.constructRoute("/api/smart-id-login/session-start/personal-code"),
			{ personalCode, legalEntityId }
		);
		
		return handleBasicResponse(result);
	},
	async startRegistrationSession(personalCode, legalEntityId) {
		const result = await makePostRequest(
			urlTools.constructRoute("/api/registration/smart-id/session-start"),
			{ personalCode, legalEntityId }
		);

		return handleBasicResponse(result);
	},
	async startUserIdSession() {
		const result = await makeGetRequest(urlTools.constructRoute("/api/smart-id-auth/session-start/user-id"));
		return handleBasicResponse(result);
	},
	async pollRegistrationSession(legalEntityId) {
		const result = await makePostRequest(urlTools.constructRoute("/api/registration/smart-id/session-poll/" + legalEntityId));
		return handlePollingResponse(result, { personalInfo: result.resultObject });
	},

	async completeRegistration(legalEntityId, userRegistrationData) {
		const result = await makePostRequest(urlTools.constructRoute("/api/registration/smart-id/complete/" + legalEntityId), userRegistrationData);
		return handleBasicResponse(result);
	},

	async startHybridSession(personalCode) {
		const result = await makePostRequest(
			urlTools.constructRoute("/api/smart-id-auth/session-start/hybrid"),
			{ personalCode }
		);

		return handleBasicResponse(result);
	},

	async pollHybridSession() {
		const result = await makePostRequest(urlTools.constructRoute("/api/smart-id-auth/session-poll/hybrid"));
		return handlePollingResponse(result);
	},

	async addSmartIdToAccount() {
		const result = await makePostRequest(urlTools.constructRoute("/api/smart-id/add"));
		return handlePollingResponse(result, { personalInfo: result.resultObject });
  	},

    async isPersonalCodeRegistered() {
        const url = urlTools.constructRoute("/api/smart-id/is-personal-code-registered");
        const result = await makePostRequest(url);
        return handleBasicResponse(result);
    }
}; 